import PaginationPages from "../Pagination";

import { PaginationStyle } from "./style";

export default function Pagination({ paginationData, setPaginationData }) {
  const RowsPerPage = () => {
    const handelChange = (event) => {
      localStorage.setItem("rowsPerPage", event.target.value);

      setPaginationData({
        page: 1,
        rowsPerPage: event.target.value,
      });
    };

    return (
      <div className="rows-per-page-container">
        <span>Rows per page: </span>
        <select
          name="rows-per-page"
          id="rows-per-page"
          value={paginationData.rowsPerPage || ""}
          onChange={handelChange}
        >
          <option value="5">5</option>
          <option value="10">10</option>
          <option value="20">20</option>
        </select>
      </div>
    );
  };

  const Pages = () => {
    return (
      <div className="pages-count">
        <PaginationPages
          pages={paginationData.totalRows}
          currentPage={paginationData.page}
          loading={false}
          emit={(currentPage) => setPaginationData({ page: currentPage })}
        />
      </div>
    );
  };

  return (
    <PaginationStyle>
      <RowsPerPage />
      <Pages />
    </PaginationStyle>
  );
}
